import { httpClient } from '@/modules/common/services/http/http-client';
import { AvailableBalanceData } from './types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/trade/v1`;
export const httpClientWithDefaultOptions = httpClient.withOptions({ baseURL });

export function getUserAvailableBalance(): Promise<AvailableBalanceData> {
  return httpClientWithDefaultOptions.get('/balance');
}
